<template>
	<div class="cardContainer">
		<div  class="title" :style="title=='新闻资讯'?';':'border-bottom:0.5px solid #EBEBEB;'">
			<div style="margin-top: 13px;display: flex;align-items: center;margin-bottom: 13px;">
				<div
					style="padding-left: 16px; font-size: 24px;font-family: Microsoft YaHei;font-style: normal;font-weight: normal;letter-spacing: 1px;margin: 0;color: rgba(0, 0, 0, 0.85);">
					{{title}}
				</div>
				<!-- 	<div
					style="font-family: Arial;font-style: normal;font-weight: normal;font-size: 0.75rem;color: rgba(0, 0, 0, 0.45);">
					<span style="padding: 0 2px;">/</span>{{lowerText}}
				</div> -->
				<div style="flex: 1;">

				</div>
				<div v-if="title!='新闻资讯'" @click="goToMore" class="MoreHover"
					style="font-size: 14px;cursor: pointer; color: #666666;padding-right: 16px;">更多 ></div>
			</div>
		</div>
		<div class="cardDetail">
			<div v-for="(item,i) in data" :key="i+'5'">
				<img style="width: 30rem;height: 17rem;padding-right: 3.125rem;margin-left: -2px;margin-top: 6px;"
					v-if="item.picture&&item.isTop&&title=='新闻资讯'&&i<1" :src="item.picture">
			</div>
			<div>
				<div class="textHover" @click="goToNoticeDetail(item)" style="width: 90%;width: 500px;"
					v-for="(item,i) in data" :key="i+'2'">
					<div v-if="item.isTop&&i<1&&title!='新闻资讯'"
						style="cursor: pointer;display:flex;justify-content: space-between;position: relative;margin-bottom: 13px;">


						<img src="../assets/images/置顶.png"
							style="width: 15px; ;position: absolute;right: 25px;top: 3px;" class="textHover">
						<div
							style="width: 200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-right: 20px;display: flex; align-items: center;font-weight: 600;">

							{{item.title}}
						</div>
						<div style="width: 160px;font-weight: 600;">{{item.createTime}}</div>
					</div>
					<div v-if="item.isTop&&i<1&&title=='新闻资讯'" style="cursor: pointer;">
						<p
							style=" font-style: normal;font-weight: 600;font-size: 20px;letter-spacing: 1px;width: 380px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
							{{item.title}}
						</p>

						<p style="font-style: normal;font-weight: 500;font-size: 1rem;letter-spacing: 1px;white-space: normal;
											width: 460px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							overflow: hidden;
							-webkit-line-clamp: 2;">
							{{item.tag}}
						</p>


					</div>


				</div>
				<div class="textHover" style="margin-right: 50px;padding:  12px 0; border-bottom: 0.5px solid #EBEBEB;" @click="goToNoticeDetail(item)"
					v-for="(item,i) in data" :key="i+'1'">

					<div v-if="item.isTop==false&&i<5"
						style="display: flex;justify-content: space-between;cursor: pointer;overflow-x: hidden;margin-left: 16px;">
						<p style="margin-left: 16px; width: 200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-right: 20px;font-size: 16px;padding: 0;margin: 0;">
							<span class="blue" style="padding-bottom: 20px;color: #EEEEEE;">o</span> {{item.title}}</p>
						<p class="blue" style="width: 160px;font-size: 16px;padding: 0;margin: 0;color: #999999;">{{item.createTime}}</p>
					</div>
					
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['data', 'lowerText', 'title'],
		methods: {
			goToNoticeDetail(data) {

				this.$router.push({
					name: 'noticeRichDetail',
					params: {
						data: data
					},
					query: {
						Ids: data.noticeId
					}
				})
				console.log(data)
			},
			goToMore() {
				this.$router.push({
					name: 'notice'
				})
			}
		}
	}
</script>

<style scoped>
	.cardContainer {
		width: 75rem;
		margin: 0 auto;
		
	}

	.cardDetail {
		display: flex;

	}

	.textHover:hover {
		color: #1890FF !important;

	}
	.textHover:hover .blue{
		color: #1890FF !important;
	
	}
	
</style>
<style>
	.MoreHover:hover {
		color: #5FB5FC !important;
	}
</style>
